export enum ActionType {
  Shake = "Shake",
  Screenshot = "Screenshot",
  FloatingButton = "FloatingButton",
  Custom = "Custom",
}
